import { EDDashboard } from '../../BaseComponents/Dashboard/EDDashboard';
import { widgets } from './Widgets';
import Widget from './Components/Widget/Widget';
import EDBox from '../../BaseComponents/EDBox/EDBox';
import { useActiveDatabaseContext } from '../../Components/ActiveDatabaseContext/ActiveDatabaseContextUtils';
import { useQuery } from '@apollo/client';
import {
  MeQuery,
  MeQueryVariables,
} from '../Delsystem/Bokning/Rutiner/Kalender/Queries/MeQuery/_QueryTypes/MeQuery';
import meQuery from '../Delsystem/Bokning/Rutiner/Kalender/Queries/MeQuery/MeQuery.gql';
import { useWidgetVisibility } from './useWidgetVisibility';

interface IProps {}

const MIN_ITEM_WIDTH = 270;
const MAX_ITEM_WIDTH = 350;
const MIN_ITEM_HEIGHT = 400;
const MAX_ITEM_HEIGHT = 400;
const GAP = 16;

const NewStartPanel: React.FC<IProps> = props => {
  const activeDatabaseContext = useActiveDatabaseContext();

  const { data: meData } = useQuery<MeQuery, MeQueryVariables>(meQuery, {
    variables: {
      dbname: activeDatabaseContext.activeDatabase ?? '',
    },
    skip: !activeDatabaseContext.activeDatabase,
  });

  const resolvedWidgets = useWidgetVisibility(widgets); // Second level filter for sys_options

  const visibleWidgets = Object.values(resolvedWidgets).filter(widget => {
    return (
      (!widget.routine ||
        activeDatabaseContext?.availableRoutines?.[widget.routine.rutinID]) &&
      !widget.isHidden?.(meData)
    );
  });

  const widgetSizes = visibleWidgets.map(widget => {
    switch (widget.size) {
      case 'doubleWidth':
        return { spanColumns: 2, spanRows: 1 };
      case 'doubleHeight':
        return { spanColumns: 1, spanRows: 2 };
      case 'standard':
      default:
        return { spanColumns: 1, spanRows: 1 };
    }
  });

  const renderedWidgets = visibleWidgets.map(widget => (
    <Widget
      key={widget.id}
      component={widget.component}
      title={widget.title}
      iconType={widget.iconType}
      routineInfo={widget.routine}
      size={widget.size}
      testId={widget.testId}
    />
  ));

  return (
    <EDBox
      sx={{
        padding: { xs: 1, sm: 2 },
        width: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        position: 'relative',
      }}
    >
      <EDDashboard
        widgetSizes={widgetSizes}
        minItemWidth={MIN_ITEM_WIDTH}
        maxItemWidth={MAX_ITEM_WIDTH}
        minItemHeight={MIN_ITEM_HEIGHT}
        maxItemHeight={MAX_ITEM_HEIGHT}
        gap={GAP}
      >
        {renderedWidgets}
      </EDDashboard>
    </EDBox>
  );
};

export default NewStartPanel;
